import {useEffect, useState} from "react";


export function useDebounceValue<T>(value : T, setInstantlyValue:T, waitTimeMs:number = 300) {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {

    if(setInstantlyValue == value){
      setDebouncedValue(value)
      return
    }

    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, waitTimeMs);

    return () => {
      clearTimeout(handler);
    };
  }, [value]);

  return debouncedValue;
}

export default useDebounceValue